import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export interface IParkInfo {
  key: string;
  name: string;
  hours: string;
  description: string;
}

// Información fija de los parques de Walt Disney World (no viene en la respuesta de Octopus).
// Los horarios son los de la maqueta y son orientativos: cambian según la fecha.
export const DISNEY_PARKS: IParkInfo[] = [
  {
    key: 'magic-kingdom',
    name: 'Magic Kingdom Park',
    hours: '8:00 A.M a 6:00 P.M',
    description: 'El parque más emblemático de Disney World: el Castillo de Cenicienta, Fantasyland, Tomorrowland, desfiles y fuegos artificiales.',
  },
  {
    key: 'hollywood-studios',
    name: 'Disney’s Hollywood Studios',
    hours: '9:00 A.M a 9:00 P.M',
    description: 'Star Wars: Galaxy’s Edge, Toy Story Land, Rock ’n’ Roller Coaster y The Twilight Zone Tower of Terror, entre otras atracciones.',
  },
  {
    key: 'epcot',
    name: 'EPCOT',
    hours: '9:00 A.M a 9:00 P.M',
    description: 'Innovación y cultura en un solo parque: atracciones como Test Track y Guardians of the Galaxy: Cosmic Rewind, y el World Showcase con pabellones de 11 países.',
  },
  {
    key: 'animal-kingdom',
    name: 'Disney’s Animal Kingdom Theme Park',
    hours: '8:00 A.M a 6:00 P.M',
    description: 'Safaris por la sabana, Pandora – The World of Avatar, el Árbol de la Vida y encuentros con animales de todo el mundo.',
  },
  {
    key: 'typhoon-lagoon',
    name: 'Disney’s Typhoon Lagoon Water Park',
    hours: '8:00 A.M a 6:00 P.M',
    description: 'Parque acuático de ambientación tropical con piscina de olas, toboganes y un río lento para recorrer en flotador.',
  },
  {
    key: 'blizzard-beach',
    name: 'Disney’s Blizzard Beach Water Park',
    hours: '10:00 A.M a 5:00 P.M',
    description: 'Parque acuático con la temática de una estación de esquí derretida, con toboganes de alta velocidad como Summit Plummet.',
  },
];

/**
 * "Info de Parques": tarjetas con foto, ícono, horario y descripción de cada parque. Es contenido fijo de la
 * vista (fotos en assets/img/parks/<tipo>/); hoy solo existe el de Disney.
 */
@Component({
  selector: 'usb-park-info',
  templateUrl: './park-info.component.html',
  styleUrls: ['./park-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParkInfoComponent {
  @Input() hotelType = 'DISNEY';

  readonly basePath = '/assets/img/parks/disney/';
  expanded: { [key: string]: boolean } = {};

  get parks(): IParkInfo[] {
    return String(this.hotelType).toUpperCase() === 'DISNEY' ? DISNEY_PARKS : [];
  }

  toggle(key: string): void {
    this.expanded[key] = !this.expanded[key];
  }

  trackByKey(_: number, park: IParkInfo): string {
    return park.key;
  }
}
